import { Slide } from '@/components/core/Slide';
import audioFile from './26-start-small.mp3';

// const autoNextDuration = 11000;
const transcript = `
  Mijn eerste tip is: begin klein. Gebruik tools als ChatGPT om ervaring op te doen met deze technologie.
  Wat voor taken voer jij eigenlijk uit met ChatGPT, Jonathan?
`;

// Jonathan: Ik gebruik het voor verschillende dingen. Bijvoorbeeld voor het schrijven van code, het maken van
// presentaties zoals deze, en het samenvatten van lange documenten. Het bespaart me enorm veel tijd.
// Je bouwt ook 'prompt engineering' vaardigheden op door het te gebruiken. Je leert wat wel en niet werkt.
// Het is als leren communiceren met een nieuwe collega die heel slim is, maar de context nog niet kent.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      // autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10">Tip: Begin Klein</h1>

        <div className="space-y-8 text-3xl">
          <div className="bg-blue-500/20 p-5 rounded-lg border-l-4 border-blue-500">
            <p>Begin met tools als ChatGPT.</p>
          </div>
        </div>
      </div>
    </Slide>
  );
};
